import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { DataAggregationLevel, InsightReportConfig, ReportLink, InsightsReportType, ReportSchedule } from './types';

const REPORTS_CONFIG_PATH = 'v1/reports/config';

export const getReportConfigForEntity = async ({
  entityType,
  entityId,
  locale,
}: {
  entityType: EntityType;
  entityId: string;
  locale: string;
}): Promise<InsightReportConfig> => {
  return merchantGatewayApi
    .get<InsightReportConfig>(
      `/merchant-analytics-api/${REPORTS_CONFIG_PATH}?entity=${entityType.toUpperCase()}&id=${entityId}`,
      {
        headers: { 'Accept-Language': locale },
      },
    )
    .then(response => response.data);
};

export const downloadReportLink = async ({
  reportId,
  locale,
}: {
  reportId: string;
  locale: string;
}): Promise<ReportLink> => {
  return merchantGatewayApi
    .get<ReportLink>(`/merchant-analytics-api/v1/reports/${reportId}/url`, {
      headers: { 'Accept-Language': locale },
    })
    .then(response => response.data);
};

export const unsubscribeReport = async ({ reportId, locale }: { reportId: string; locale: string }): Promise<null> => {
  return merchantGatewayApi
    .post(`/merchant-analytics-api/v1/reports/${reportId}/unsubscribe`, {
      headers: { 'Accept-Language': locale },
    })
    .then(response => response.data);
};

export const createReportRequest = async ({
  venueIds,
  reportType,
  metrics,
  aggregationLevel,
  schedules,
  entityType,
  entityId,
}: {
  venueIds: string[];
  reportType: InsightsReportType;
  metrics: string[];
  aggregationLevel: DataAggregationLevel;
  schedules: ReportSchedule[];
  entityType: EntityType;
  entityId: string;
}) => {
  return merchantGatewayApi
    .post('/merchant-analytics-api/v1/reports/request', {
      venueIds,
      reportType,
      metrics,
      aggregationLevel,
      schedules,
      sourceEntityType: entityType.toUpperCase(),
      sourceEntityId: entityId,
    })
    .then(response => response.data);
};
